import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { CampLogo } from './CampLogo.jsx';

// Nav adapts to role: staff only sees "ของฉัน"; manager/admin get the full set.
const MANAGER_TABS = [
  { to: '/', label: 'หน้าหลัก', icon: '◴', end: true },
  { to: '/employees', label: 'พนักงาน', icon: '○' },
  { to: '/issue-warning', label: 'ตักเตือน', icon: '⚠︎' },
  { to: '/recognize', label: 'ชมเชย', icon: '★' },
  { to: '/me', label: 'ของฉัน', icon: '☺' },
];

const STAFF_TABS = [
  { to: '/me', label: 'ของฉัน', icon: '☺', end: true },
];

export function BottomNav() {
  const { role } = useAuth();
  const tabs = role === 'staff' ? STAFF_TABS : MANAGER_TABS;
  return (
    <nav className="nav">
      <div className="nav-brand">
        <CampLogo height={22} />
        <span className="brand-name">ห้องปกครอง</span>
      </div>
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end}>
          <span className="ni">{t.icon}</span>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
